export default function Features() {
  return (
    <section id="features" className="py-32 bg-gradient-to-br from-purple-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-16">
          <h2 className="text-7xl font-thin text-gray-900 mb-4">Our Core Features</h2>
          <p className="text-base text-gray-500">What makes our VPN different</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-purple-900 to-purple-700 rounded-3xl p-10 flex flex-col justify-between min-h-[420px] hover:scale-105 transition-transform duration-300">
            <div>
              <div className="w-14 h-14 bg-purple-800 rounded-full flex items-center justify-center mb-8">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-4xl font-bold text-white mb-6 leading-tight">
                Military-Grade Encryption
              </h3>
            </div>
            <p className="text-sm text-purple-200 leading-relaxed">
              Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide. Every bit of information you send or receive is completely secure from prying eyes.
            </p>
          </div>

          <div className="relative rounded-3xl overflow-hidden min-h-[380px] hover:scale-105 transition-transform duration-300">
            <img
              src="https://public.readdy.ai/ai/img_res/53e32ad19080016a59903ba66950ec61.jpg"
              alt="Privacy Protection"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
            <div className="relative h-full flex flex-col justify-between p-10">
              <div className="inline-flex items-center space-x-2 bg-black/50 backdrop-blur-sm px-4 py-2 rounded-full self-start">
                <i className="ri-lock-line text-white text-lg"></i>
                <span className="text-white text-sm font-medium">PRIVACY</span>
              </div>
              <h3 className="text-4xl font-bold text-white leading-tight">
                Zero-Logs Policy
              </h3>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-10 flex flex-col justify-between min-h-[340px] shadow-lg hover:scale-105 transition-transform duration-300">
            <div>
              <h3 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">
                Lightning Fast Speeds
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-8">
                Experience blazing-fast connection speeds with our optimized server network. Stream, download, and browse without any lag or buffering.
              </p>
            </div>
            <div className="flex items-center justify-center space-x-2 py-6">
              <div className="w-2 h-16 bg-teal-500 rounded-full animate-pulse"></div>
              <div className="w-2 h-24 bg-teal-400 rounded-full animate-pulse" style={{ animationDelay: '0.1s' }}></div>
              <div className="w-2 h-32 bg-teal-500 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
              <div className="w-2 h-20 bg-teal-400 rounded-full animate-pulse" style={{ animationDelay: '0.3s' }}></div>
              <div className="w-2 h-28 bg-teal-500 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
          <div className="bg-white rounded-3xl p-10 shadow-lg hover:scale-105 transition-transform duration-300">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-global-line text-teal-600 text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Global Server Network</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Connect to servers in multiple countries worldwide. Access geo-restricted content and enjoy a truly global internet experience.
            </p>
          </div>

          <div className="bg-white rounded-3xl p-10 shadow-lg hover:scale-105 transition-transform duration-300">
            <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-device-line text-purple-600 text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Multi-Device Support</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Protect all your devices with a single account. Compatible with Windows, Mac, iOS, Android, and more.
            </p>
          </div>

          <div className="bg-white rounded-3xl p-10 shadow-lg hover:scale-105 transition-transform duration-300">
            <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-customer-service-2-line text-orange-600 text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">24/7 Support</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Our dedicated support team is always ready to help you. Get assistance whenever you need it, day or night.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
